export type MeetingTypeValue =
  | 'Descoberta'
  | 'Apresentação de Proposta'
  | 'Validação'
  | 'Follow-up'

export type LeadConvertEntryStage = 'reuniao_agendada' | 'proposta_elaboracao'

export type MeetingTypeOption = {
  value: MeetingTypeValue
  label: string
  /** Rótulo alternativo na abertura de negociação (Minha Carteira). */
  convertLabel?: string
  shortLabel: string
  description: string
  /** Tipos permitidos ao abrir negociação a partir da Minha Carteira (lead novo). */
  allowedOnLeadConvert: boolean
  /** Etapa inicial do deal quando convertido da carteira com este tipo. */
  convertEntryStage?: LeadConvertEntryStage
  disabledReason?: string
}

export const MEETING_TYPE_OPTIONS: MeetingTypeOption[] = [
  {
    value: 'Descoberta',
    label: 'Descoberta',
    shortLabel: 'Descoberta',
    description: 'Entender dores, budget e decisor.',
    allowedOnLeadConvert: true,
    convertEntryStage: 'reuniao_agendada',
  },
  {
    value: 'Apresentação de Proposta',
    label: 'Apresentação de proposta',
    convertLabel: 'Proposta direta',
    shortLabel: 'Proposta direta',
    description: 'Necessidade clara — elabore a proposta até a reunião de apresentação.',
    allowedOnLeadConvert: true,
    convertEntryStage: 'proposta_elaboracao',
  },
  {
    value: 'Follow-up',
    label: 'Follow-up',
    shortLabel: 'Follow-up',
    description: 'Retomar contato com quem já conversou.',
    allowedOnLeadConvert: true,
    convertEntryStage: 'reuniao_agendada',
  },
  {
    value: 'Validação',
    label: 'Validação',
    shortLabel: 'Validação',
    description: 'Validar escopo, condições ou objeções após envio.',
    allowedOnLeadConvert: false,
    disabledReason: 'Use quando a proposta já foi enviada ou negociada.',
  },
]

export function getMeetingTypeOption(value: string): MeetingTypeOption | undefined {
  return MEETING_TYPE_OPTIONS.find((option) => option.value === value)
}

export function meetingTypesForContext(context: 'leadConvert' | 'deal'): MeetingTypeOption[] {
  if (context === 'deal') return MEETING_TYPE_OPTIONS
  return MEETING_TYPE_OPTIONS.filter((option) => option.allowedOnLeadConvert)
}

/** Tipos relevantes ao agendar — oculta Validação até etapas pós-proposta. */
export function meetingTypesForDealStage(etapa: string): MeetingTypeOption[] {
  const preProposal = ['qualificado', 'reuniao_agendada', 'reuniao_realizada'].includes(etapa)
  if (preProposal) {
    return MEETING_TYPE_OPTIONS.filter((option) => option.value !== 'Validação')
  }
  return MEETING_TYPE_OPTIONS
}

export const DEFAULT_MEETING_TYPE: MeetingTypeValue = 'Descoberta'

export function resolveLeadConvertEntryStage(tipo: string): LeadConvertEntryStage {
  return getMeetingTypeOption(tipo)?.convertEntryStage ?? 'reuniao_agendada'
}

export function isDirectProposalLeadConvert(tipo: string): boolean {
  return resolveLeadConvertEntryStage(tipo) === 'proposta_elaboracao'
}

export function leadConvertSuccessMessage(tipo: string): string {
  if (isDirectProposalLeadConvert(tipo)) {
    return 'Negociação aberta em Elaborar Proposta — monte a proposta até a reunião!'
  }
  return 'Negociação criada com reunião agendada!'
}
